// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","infoText":"AddInternalOrderIdSection_infoText__RnF53","input":"AddInternalOrderIdSection_input__3YZJR"};